import { useCallback, useEffect, useMemo, useState } from 'react';

export const DEFAULT_TABLE_SEARCH_DEBOUNCE_MS = 500;

export type TableSearchState = {
  searchInput: string;
  setSearchInput: (value: string) => void;
  debouncedSearch: string;
  clearSearch: () => void;
};

/**
 * Единый источник истины для строки поиска таблиц: мгновенный ввод + debounced строка для запросов/подсветки.
 * Семантика trim совпадает с ProjectsSearchContext / ScheduleSearchContext (debounced = trim(searchInput)).
 */
export function useTableSearchState(debounceMs: number = DEFAULT_TABLE_SEARCH_DEBOUNCE_MS): TableSearchState {
  const [searchInput, setSearchInput] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');

  useEffect(() => {
    const t = window.setTimeout(() => {
      setDebouncedSearch(searchInput.trim());
    }, debounceMs);
    return () => window.clearTimeout(t);
  }, [searchInput, debounceMs]);

  const clearSearch = useCallback(() => {
    setSearchInput('');
    setDebouncedSearch('');
  }, []);

  return useMemo(
    () => ({
      searchInput,
      setSearchInput,
      debouncedSearch,
      clearSearch,
    }),
    [searchInput, setSearchInput, debouncedSearch, clearSearch]
  );
}
